import { createApp, defineAsyncComponent } from 'vue';
import App from './App.vue';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import router from './router';
import { IonicVue } from '@ionic/vue';
import { createPinia } from 'pinia';
import BButton from '@/components/BButton.vue';
import BInput from '@/components/BInput.vue';
import BRadio from '@/components/BRadio.vue';
import BStartButton from '@/components/BStartButton.vue';
import BCheckboxItem from '@/components/BCheckboxItem.vue';
import BRadioCheckbox from '@/components/BRadioCheckbox.vue';

// Lazy: BVideo pulls in video.js + the Mux kit (~0.5 MB); load it only when
// a page actually renders a <BVideo>, not in the app entry bundle.
const BVideo = defineAsyncComponent(() => import('@/components/BVideo.vue'));

import './assets';
import { createI18n } from "vue-i18n";
import { languages } from './locale';
import { useStore } from '@/stores/main';

// Get the saved locale from localStorage or use Swedish as default
const savedLocale = localStorage.getItem('userLocale') || 'sv';

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: savedLocale,
  fallbackLocale: 'sv',
  messages: languages
});

// i18n instance is now handled directly in components

const pinia = createPinia();

const app = createApp(App)
  .use(IonicVue, {
    mode: 'ios',
    swipeBackEnabled: false,
  })
  .use(router)
  .use(pinia)
  .use(i18n) // Add the i18n plugin
  .component('BButton', BButton)
  .component('BInput', BInput)
  .component('BRadio', BRadio)
  .component('BRadioCheckbox', BRadioCheckbox)
  .component('BVideo', BVideo)
  .component('BStartButton', BStartButton)
  .component('BCheckboxItem', BCheckboxItem);

router.isReady().then(() => {
  app.mount('#app');

  // Deliver answers that were queued while offline (stores/main.ts
  // flushAnswerOutbox): on app start and whenever connectivity returns.
  const store = useStore(pinia);
  store.flushAnswerOutbox();
  // Subsequent reconnects are handled once by useAppConnection.
});
